module.exports = __webpack_public_path__ + "img/urban_utvikling_paavirkning_diffuse_utslipp.bdf1c9e5.jpg";